import type {
	CustomItem,
	DropTimelineType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropTimeline = (
	item: Item | CustomItem
): item is DropTimelineType => {
	return !!(item && item.__typename === 'Drop_Timeline');
};
